<div class="row div-cenered m-3">
  Выберите, что вы хотите сделать
</div>
<div class="row m-3 div-cenered">
  <div class="col">
    <button
      class='btn btn-log btn-sm'
      (click)="change('edit')"
    >
      Редактировать встречу
    </button>
  </div>
  <div class="col">
    <button
      class='btn btn-log btn-sm'
      (click)="change('add')"
    >
      Добавить игрока
    </button>
  </div>
</div>
